function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.44444 2 2 6.44444 2 12C2 17.5556 6.44444 22 12 22C12.8889 22 13.6667 21.2222 13.6667 20.3333C13.6667 19.8889 13.5556 19.5556 13.2222 19.2222C13 18.8889 12.7778 18.5556 12.7778 18.1111C12.7778 17.2222 13.5556 16.4444 14.4444 16.4444H16.4444C19.5556 16.4444 22 14 22 10.8889C22 6 17.5556 2 12 2Z",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 12.5,
  r: 1.5,
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 7.5,
  r: 1.5,
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 7.5,
  r: 1.5,
  strokeWidth: 2
});

function SvgOptions(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-options",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.aad1768e.svg";
export { ForwardRef as ReactComponent };